import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Container } from "react-bootstrap";
import { Skeleton } from "@mui/material";


import { Footer, FooterForm, NavBar, NewButton } from '../components';
import { tracking } from "../../../utils/tracking";
import { Link } from 'react-router-dom';
import styles from "./Agenda.module.css";

function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`simple-tabpanel-${index}`}
         aria-labelledby={`simple-tab-${index}`}
         {...other}
      >
         {value === index && (
            <Box sx={{ p: 4, backgroundColor: "#212529" }}>
               <Typography>{children}</Typography>
            </Box>
         )}
      </div>
   );
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.number.isRequired,
   value: PropTypes.number.isRequired,
};

export const AgendaTemp = () => {
   const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/agenda-banner-desktop.jpg'
   const MOBILE_IMG_URL = '../../../../assets/events/etvs23/agenda-banner-mobile.jpg'
   const [isLoading, setIsLoading] = useState(true);
   const [imageSource, setImageSource] = useState('');

   document.title = "Emerging Tech Venture Summit | Agenda";

   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/agenda/agenda.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
      function updateImage() {
         if (window.matchMedia('(min-width: 900px)').matches) {
            setImageSource(DESKTOP_IMG_URL);
         } else {
            setImageSource(MOBILE_IMG_URL);
         }
      }
      window.addEventListener('resize', updateImage);
      updateImage();
      return () => window.removeEventListener('resize', updateImage);
   });


   return (
      <div>
         <NavBar />
         <Container className={styles.banner} fluid>
            {isLoading ?
               <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: imageSource === DESKTOP_IMG_URL ? '65vh' : '100vh', position: 'initial !important', backgroundColor: '#0F1A28' }}>
                  <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '45%' : '40%', top: '40%' }} />
                  <img
                     onLoad={() => setIsLoading(false)}
                     src={imageSource}
                     alt='home-img'
                     style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
               </Skeleton>
               :
               <img
                  src={imageSource}
                  loading="eager"
                  alt='home-img'
                  style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
               />

            }
            {
               !isLoading &&
               <div className={styles.itemsOnImg}>
                  <h2 >Explore Engaging Content</h2>
                  <Link to='/events/etvs23/registration' onClick={() => tracking(290)} className={styles.btn}>
                     <NewButton name='GET YOUR TICKET' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </Link>
               </div>
            }
         </Container>


         <h5 style={{ textAlign: 'center', marginTop: '1em', padding: '1em' }}><b>Please Note:</b> Agenda subject to change</h5>
         <div name="bizzabo-web-agenda" data-unique-name="419957" data-internal-website-base-url="https://widget.youngstartup.com/etvs23"></div>
         <a
            className="bizzabo-link-class"
            style={{
               textAlign: "right",
               paddingRight: "17px",
               textDecoration: "none",
               width: "100%",
               display: "inline-block",
               marginTop: "5px",
               boxSizing: "border-box",
            }}
            href="https://www.bizzabo.com?utm_source=tickets_widget&utm_medium=powered_by&utm_campaign=tickets_widget"
            target="_blank"
            rel="noreferrer"
         >
            {/* Powered by Bizzabo */}
         </a>
         <FooterForm />
         <Footer />
      </div >
   );
};
